module.exports = __webpack_public_path__ + "assets/jeepay.3067ac81.svg";